import React from "react";
import { Card, Button } from "react-bootstrap";

const StarterCard = ({ scrollToConsult }) => {
  return (
    <div className="container d-flex justify-content-center align-items-center mb-5 ">
      <Card
        style={{
          width: "100%",
          // padding: "40px",
          borderRadius: "32px",
        }}
        className="bg-theme p-md-5 py-5 px-2"
      >
        <Card.Body>
          <Card.Title as={"h2"} className="fs-40 fw-700 text-center text-white">
            Ready to Get Started?
          </Card.Title>
          <Card.Text className="fs-17 text-center text-white">
            Discover new things and explore exciting opportunities.
          </Card.Text>
          <div className="d-flex justify-content-center">
            <div className="d-flex my-2 my-lg-0 me-1" onClick={scrollToConsult}>
              <a className="fs-14 btn btn-golden animate__animated animate__slideInUp">
                {" "}
                BOOK A FREE CONSULTATION{" "}
              </a>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default StarterCard;
